export function WordIcon({ name = "book" }: { name?: "book" | "add" | "save" | "check" | "close" | "edit" | "audio" | "sort" | "delete" | "archive" | "back" | "next" }) {
  const paths = {
    book: "M3 3h7l2 2 2-2h7v17h-7l-2 2-2-2H3z M12 5v17",
    add: "M12 4v16M4 12h16", save: "M4 3h13l4 4v14H3V3h1 M7 3v6h10V3 M7 21v-8h10v8",
    check: "m4 12 5 5L20 6", close: "m5 5 14 14M19 5 5 19", edit: "m4 16-1 5 5-1L21 7l-4-4z M14 6l4 4",
    audio: "M4 9h4l5-5v16l-5-5H4z M17 8q6 4 0 8", sort: "M8 3v18M4 7l4-4 4 4M16 21V3m-4 14 4 4 4-4",
    delete: "M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7",
    archive: "M3 3h18v5H3zM5 8v13h14V8M9 12h6",
    back: "m15 4-8 8 8 8", next: "m9 4 8 8-8 8",
  };
  return <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[name]} /></svg>;
}
